import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import styled from '../teacherPages/teachersList/Teachers.module.css'
import { Link } from 'react-router-dom'
import maleAvatar from "../../assets/maleAvatar.webp"
import { db, auth } from '../../firebase/firebase'
import { getDocs, collection, query, where } from 'firebase/firestore';   
import { useEffect, useState } from 'react'
import { SubmitButton } from '../../components/styled/styledbuttons/buttons'
import { useTeacher } from '../../context/TeacherProvider'
import { useTranslation } from 'react-i18next'
import { isApprovedTeacher } from '../../utils/teacherStatus'
const SelectTeachers = ({ setTeacherSelected, setSelectedTeacherID, setTeacherEvents}) => {
  const { setTeacherID } = useTeacher();
  const { t } = useTranslation();
   const [teacherList, setTeacherList] = useState([]) 
  
   const teacherCollectionRef = collection(db, "teachers");
   
   const getTeacherList = async () => {
       const data = await getDocs(teacherCollectionRef)
       const filteredData = data.docs
         .map((doc) => ({...doc.data(), id: doc.id}))
         .filter(isApprovedTeacher)
       setTeacherList(filteredData)
     }

    const handleTeacherSelect = (teacherID) => {
        // setTeacherSelected(true)
        setTeacherID(teacherID)
        setSelectedTeacherID(teacherID)
    }
    
  useEffect(() => {
        getTeacherList()
        
      }, []);
  return (
  <>
  
  <Navbar />
  <div className={styled.container}>
   {teacherList.map((teacher) => {
    const {userId, firstName, lastName, gender, birthYear, profileImage} = teacher
 
    return (
        <div className={styled.card} key={userId}>
        <img className={styled.img} src={profileImage || maleAvatar } />
        <div className={styled.name}>
          <h2>{t('SelectTeacher.Teacher')}  {firstName} {lastName}</h2>
        </div>
        <div className={styled.genAge}>
          <h3>
            {birthYear != null && birthYear !== "" && !Number.isNaN(Number(birthYear))
              ? new Date().getFullYear() - Number(birthYear)
              : null}
          </h3>
          <h3>{gender}</h3>
        </div>
        <SubmitButton style={{ width: '80%', marginBottom: "10px" }} onClick={ () => handleTeacherSelect(userId)} >{t('SelectTeacher.Book a Lesson')}</SubmitButton>
      </div>
    )
   })}
  </div>
  </>
  )
}

export default SelectTeachers